import { useSearchParams as useSearchParamsRouter } from 'react-router';

/**
 * Hook to get a specific search parameter from the URL
 * @param paramName - The name of the search parameter to retrieve
 * @returns The value of the search parameter or null if not found
 */
function useSearchParams(paramName: string): string | null {
    const [searchParams] = useSearchParamsRouter();
    return searchParams.get(paramName);
}

export default useSearchParams;
